import { apiSlice } from "../../Api/apiSlice";

const quizApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get all student Assignment mark
    getStudentAssignmentMark: builder.query({
      query: (sid) => `/assignmentMark?student_id_like=${sid}`,
    }),
    // Get all student Quiz mark
    getStudentQuizMark: builder.query({
      query: (sid) => `/quizMark?student_id_like=${sid}`,
    }),

    // getAll Student
    getAllStudent: builder.query({
      query: () => `/users?role_like=student`,
    }),
    // Get all Quiz Mark
    getAllQuizMark: builder.query({
      query: () => `/quizMark`,
    }),

    //Get all AssignmentMark
    getAllAssignmentMark: builder.query({
      query: () => `/assignmentMark`,
    }),
  }),
});
export const {
  useGetAllStudentQuery,
  useGetAllQuizMarkQuery,
  useGetAllAssignmentMarkQuery,
  useGetStudentAssignmentMarkQuery,
  useGetStudentQuizMarkQuery,
} = quizApi;
